/**
 * Session timeout configuration
 * All values are in milliseconds
 */

// Get configuration from environment variables or use defaults
const SESSION_CONFIG = {
  // Access token expiry time for session UI (keep in line with server JWT_ACCESS_EXPIRES_MS)
  TOKEN_EXPIRY_MS: process.env.REACT_APP_SESSION_TIMEOUT
    ? parseInt(process.env.REACT_APP_SESSION_TIMEOUT)
    : 8 * 60 * 60 * 1000,

  // Warning time - how many minutes before expiry to show warning (default: 10 minutes)
  WARNING_TIME_BEFORE_EXPIRY_MINUTES: process.env.REACT_APP_SESSION_WARNING_TIME
    ? parseInt(process.env.REACT_APP_SESSION_WARNING_TIME)
    : 10,

  // How often to check session expiry (default: 60 seconds)
  CHECK_INTERVAL_MS: process.env.REACT_APP_SESSION_CHECK_INTERVAL
    ? parseInt(process.env.REACT_APP_SESSION_CHECK_INTERVAL)
    : 60 * 1000,

  // Auto-refresh threshold - auto-refresh token if less than this time remaining (default: 15 minutes)
  AUTO_REFRESH_THRESHOLD_MINUTES: process.env.REACT_APP_AUTO_REFRESH_THRESHOLD
    ? parseInt(process.env.REACT_APP_AUTO_REFRESH_THRESHOLD)
    : 15,
};

// Calculate warning time in milliseconds
SESSION_CONFIG.WARNING_TIME_MS =
  SESSION_CONFIG.TOKEN_EXPIRY_MS -
  (SESSION_CONFIG.WARNING_TIME_BEFORE_EXPIRY_MINUTES * 60 * 1000);

// Calculate auto-refresh threshold in milliseconds
SESSION_CONFIG.AUTO_REFRESH_THRESHOLD_MS =
  SESSION_CONFIG.AUTO_REFRESH_THRESHOLD_MINUTES * 60 * 1000;

export default SESSION_CONFIG;

/**
 * Example .env configuration:
 *
 * # Session timeout in milliseconds (default: 2 hours = 7200000)
 * REACT_APP_SESSION_TIMEOUT=7200000
 *
 * # Show warning X minutes before expiry (default: 10)
 * REACT_APP_SESSION_WARNING_TIME=10
 *
 * # Check session every X milliseconds (default: 60000 = 1 minute)
 * REACT_APP_SESSION_CHECK_INTERVAL=60000
 *
 * # Auto-refresh if less than X minutes remaining (default: 15)
 * REACT_APP_AUTO_REFRESH_THRESHOLD=15
 */
